module.exports = __webpack_public_path__ + "static/media/Mobile_Data_GESTÃO_DE_PROJETOS_DE_FORMA_EFICIENTE_E_EFICAZ_USANDO_PMI.1cd9b104.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/gestao_proj/Mobile_Data_GESTÃO_DE_PROJETOS_DE_FORMA_EFICIENTE_E_EFICAZ_USANDO_PMI.png
// module id = 88
// module chunks = 0